import React, { useState, useEffect } from 'react';
import HomeFilter from './HomeFilter';

const NFT = ({ currentPage, setCurrentPage, totalPages, setTotalPages, loading, setLoading }) => {
  const [coins, setCoins] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchNFTCoins = async () => {
      const query = new URLSearchParams({ page_number: currentPage }).toString();
      try {
        setLoading(true);
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/coins/nft?${query}`);
        
        if (!response.ok) {
          throw new Error(`Failed to fetch NFT data (status ${response.status})`);
        }
        
        const data = await response.json();
        
        if (data.error) {
          throw new Error(data.error);
        }
        
        // Format the data for display
        const formattedData = data.map(coin => ({
          ...coin,
          current_price: coin.current_price?.toLocaleString('en-US', {
            //style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: coin.current_price < 1 ? 6 : 2
          }),
          market_cap: coin.market_cap?.toLocaleString('en-US', {
            //style: 'currency',
            currency: 'USD',
            maximumFractionDigits: 0
          }),
          total_volume: coin.total_volume?.toLocaleString('en-US', {
            //style: 'currency',
            currency: 'USD',
            maximumFractionDigits: 0
          })
        }));
        
        setCoins(formattedData);
        setError(null);
      } catch (err) {
        console.error('Error fetching NFT coins:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchNFTCoins();
  }, [currentPage]);

  const handlePageChange = (direction) => {
    console.log(direction);
    setCurrentPage((prevPage) => {
      if (direction === 'prev') {
        return Math.max(prevPage - 1, 1); // Minimum page is 1
      } else if (direction === 'next') {
        return Math.min(prevPage + 1, totalPages); // Maximum page is totalPages
      }
      window.scrollTo({ top: 0, behavior: "smooth" });
      return prevPage;
    });
  };

  if (error) return <div className="text-center py-10 text-red-500">{error}</div>;

  return (
    <div className="home_wrapper">
      <HomeFilter 
        coins={coins} 
        showTimeframes={true}
      />
      <div className="btn_mainsec">
        <button
          className="btn_style"
          onClick={() => handlePageChange('prev')}
          disabled={currentPage === 1}
        >
          Previous
        </button>

        <button
          className="btn_style"
          onClick={() => handlePageChange('next')}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default NFT;